import { render, staticRenderFns } from "./page-search-header.vue?vue&type=template&id=1369c2f8&scoped=true&"
import script from "./page-search-header.vue?vue&type=script&lang=js&"
export * from "./page-search-header.vue?vue&type=script&lang=js&"
import style0 from "./page-search-header.vue?vue&type=style&index=0&id=1369c2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1369c2f8",
  null
  
)

component.options.__file = "page-search-header.vue"
export default component.exports